<template>
    <div class="flex-fill d-flex position-relative test2">
		<div v-if="showLoader" class="loader1">
					<div>
						<div class="lds-ripple">
						<div></div>
						<div></div>
						</div>
					</div>
				</div>
		<div v-if="convo || prospect" class="msglogdiv bg-white border flex-fill d-flex flex-column overflow-auto">
			<div class="border-bottom justify-content-between position-relative p-2 d-flex">
				<b-button id="ConvoBackButton" variant="outline" class="position-relative" @click="$emit('open', 'list')">
					<v-icon name="arrow-left" scale="1" class="text-blue" />
				</b-button>
				<div class="w-100">
					<div v-if="prospect" class="d-flex before-icon">
						
						<h5 style="display: flex;align-items: end;">{{$parseAlias(prospect)}}
							
							<span 
								v-if="isOverDue.val"
								:class="getClassName"
								:id="this.getId" 
								style="padding:0px;background-color: transparent;border-color: transparent;"
							>!</span>
							<b-popover 
								:target="this.getId" 
								triggers="hover" 
								placement="topright" 
								container="my-container" 
								ref="popover"
							>
								<b-table-simple v-if="prospect.Tasks" bordered striped responsive hover class="mx-auto text-left middle-grid-sc">
									<b-thead head-variant="light">
										<b-tr class="text-center">
											<b-th>Due Date</b-th>
											<b-th>Task</b-th>
										</b-tr>
									</b-thead>
									<b-tbody>
										<b-tr
											:key="task.CreatedOn"
											class="text-left position-relative"
											v-for="task of TaskList"
											:class="{'table-danger': task.Status == 'draft' && (task.DueOn <= Date.now())}"
										>
											<b-td>{{$parseDate(task.DueOn)}}</b-td>
											<b-td class="pr-5 position-relative">{{task.Description}}
												<b-button v-if="task.Status != 'compeleted'"
													style="right: 25px"
													variant="outline"
													class="center-vert"
													@click="compeleteTask(task)"
												>
													<v-icon class="text-blue" name="check" />
												</b-button>
												<b-button
													style="right: 0"
													variant="outline"
													class="center-vert"
													@click="removeTask(task)"
												>
													<v-icon class="text-blue" name="times" />
												</b-button>
											</b-td>
										</b-tr>
									</b-tbody>
								</b-table-simple>
							</b-popover>
							<div v-if="!prospect.Starred" @click.stop.prevent="startMessage()">
								<v-icon :class="{ 'show_star': !prospect.Starred }" class="text-white start-default" scale="1" name="star" ></v-icon>
							</div>
							<span @click.stop.prevent="unStartMessage()" style="margin-left: 0px;margin-top: -6px;">
								<v-icon v-if="prospect.Starred" class="text-blue start-default" scale="1" name="star" ></v-icon>
							</span>
						</h5>	
						<span class="ml-auto my-auto">Created: {{$parseDate(prospect.DateCreated)}}<br>
						<!-- <span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length && prospect.CciMap.Priority" class="ml-auto my-auto w-100 d-inline-block text-right"> <a style="color:#007bff" class="cursor-pointer" @click="openPriorityModal({},'openedFromAssessment')">Priority: {{prospect.CciMap.Priority}}</a></span> -->
						<span v-if="prospect && prospect.hasOwnProperty('CciMap') && Object.keys(prospect.CciMap).length" class="ml-auto my-auto w-100 d-inline-block text-right"> <a style="color:#007bff" class="cursor-pointer" @click="openPriorityModal({},'openedFromAssessment')">Priority: {{prospect.CciMap.Priority}}</a></span>
						</span>
					</div>
						<div class="d-flex">
						<h6 v-if="prospect">{{$parseNumber(prospect.Number)}}</h6>
				
					<h5 v-else >{{$parseNumber(convo.ClientNumber)}}</h5>
					<div v-if="hasCarrierType">
						<strong v-if="prospect.CarrierType == 'mobile' || prospect.CarrierType == 'voip'" v-b-tooltip.hover title="Validated mobile phone number" class="text-danger" style="margin-left:12px">
							<v-icon name="check" class="text-blue" />
						</strong>
						<strong v-else v-b-tooltip.hover title="Not a valid mobile number. Prospect can’t be messaged." class="text-danger" style="margin-left:12px">
							<svg style="width:24px;height:24px" viewBox="0 0 24 24">
								<path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
							</svg>
						</strong>
					</div>                                                                                                                                                                                                                                                 		
					<div v-if="convo && convo.needHumanFeedback" style="margin-left: 2.5rem;color: white;background-color: #fd4c4c;text-align: center;float: right;padding:7px 10px !important;">
						<span>Human Feedback Needed  <span @click="updateNeedHumanNeeded" style="cursor:pointer;">X</span> </span>
					</div>
					
					<div v-if="convo && convo.autoSms !== undefined && convo.autoSms" class="d-flex align-items-center ml-auto">
						<strong v-b-tooltip.hover title="Autopilot is an experimental new tool for assisting with early conversations with candidates. Autopilot is currently in beta. Talk to your HiringCenter or ThirdPool account manager if you have questions." class="text-danger" style="margin-left:12px;margin-bottom: 10px;margin-right: 4px;">
							<v-icon name="info-circle" class="text-blue" />
						</strong>
						<label>Autopilot:</label>
						<b-form-checkbox v-model="convo.autoSms" name="check-button" switch @change="updateAutoSms($event)" style="margin-bottom: 9px;left: 5px;"></b-form-checkbox>
					</div>
					<div v-else class="d-flex align-items-center ml-auto">
						<strong v-b-tooltip.hover title="Autopilot is an experimental new tool for assisting with early conversations with candidates. Autopilot is currently in beta. Talk to your HiringCenter or ThirdPool account manager if you have questions." class="text-danger" style="margin-left:12px;margin-bottom: 10px;margin-right: 4px;">
							<v-icon name="info-circle" class="text-blue" />
						</strong>
						<label>Autopilot:</label>
						<b-form-checkbox v-if="convo && convo.autoSms !== undefined && convo.autoSms" v-model="convo.autoSms" name="check-button" switch @change="updateAutoSms($event)" style="margin-bottom: 9px;left: 5px;"></b-form-checkbox>
					</div>
					</div>
					
					
				</div>
				<!-- <b-button  variant="outline" class="position-relative" @click="openEmailModal()"  style="margin-right: -20px;">
					<v-icon name="envelope-o" scale="3" class="text-blue" />
				</b-button> -->
				<b-button variant="outline" class="emailndcallbtn position-relative" @click="openEmailModal({},'withoutDetails')" style="padding-right: 0px;">
					<v-icon name="envelope" scale="2" class="text-blue" />
				</b-button>
				<b-button v-if="prospect" variant="outline" class="emailndcallbtn position-relative" @click="makeCallClick()">
					<v-icon name="phone-square-alt" scale="2" class="text-blue" />
				</b-button>
				<!-- <b-button variant="outline" class="position-relative" @click="$emit('open', 'prosp')">
					<v-icon name="info-circle" scale="3" class="text-blue" />
				</b-button> -->
				<b-button variant="outline" class="emailndcallbtn deviceProsInfoTab position-relative" @click="openProspectDetails()" style="padding:0px;">
					<v-icon name="info-circle" scale="2" class="text-blue" />
				</b-button>
				
			</div>
			<div ref="messageLog" v-if="messages.length || mails.length || phones.length || Object.keys(sending).length || Object.keys(failed).length" v-on:scroll="OnScroll" class="p-3 flex-fill d-flex flex-column overflow-auto">
				<div class="flex-fill" />
				<!-- <div v-if="prospect && prospect.hasOwnProperty('Number') && prospect.Number">  -->
				<div v-if="prospect"> 
				<Message
					:key="message.id"
					:message="message"
					:testAutoConvotemp="testAutoConvotemp"
					@resend="resendError(message)"
					@delete="deleteError(message)"
					@cancelClick="cancelClick()"
					@openEmailM="openEmailModal"
					@openCallM="openCallModal"
					v-for="message in collatedMessages"
					@editMessage="editMessage"
					@deleteMessage="deleteMessage"
					
				/>
				</div>
				<div v-else class="flex-fill position-relative">
					<h6 class="text-black-50 center">This conversation is empty </h6>
				</div>
			</div>
			<div v-else class="flex-fill position-relative">
				<h6 class="text-black-50 center">This conversation is empty</h6>
			</div>
			<div v-if="hideDiv && messageType == 'message'" class="border bg-light d-flex align-items-end p-3">
				<div style="position:relative;    display: flex;justify-content: space-between;width: 100%;">
					<!-- <v-icon name="spinner"  scale="1.5" class=" m-2 text-blue" /> -->
					<span v-if="!uplodedFilePath">Loading...</span>
					<a v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<img width="60" :src="uplodedFilePath"/>
					</a>
					<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<v-icon scale="2.5" name="music" />
					</a>
					<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<v-icon scale="2.5" name="video" />
					</a>
					<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
						<v-icon scale="2.5" name="file" />
					</a>
					<b-button variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
						<v-icon name="times"  scale="1.5" class=" m-2 text-blue" />
					</b-button>
				</div>
				
			</div>
			<div id="onlyDesktop" class="border bg-light d-flex align-items-center">

        <!-- NARROW BROWSER AND DEVICES -->
        <!-- <b-dropdown id="dropdown-md" title="More Options" class="m-md-2 mobilemegoptn">
          <b-dropdown-item>
            <b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
              <v-icon name="file-alt" scale="1.2" class="m-2 text-blue" />
            </b-button>
          </b-dropdown-item>
          <b-dropdown-item v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))">
            <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
              <v-icon name="upload" scale="1.2" class="text-blue"  />
            </b-button>
          </b-dropdown-item>
          <b-dropdown id="dropdown-m" v-if="user.Variables" right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
            <b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
          </b-dropdown>
        </b-dropdown>
        
        <input id="fileUpload" type="file" @change="changeFile($event,'message')" hidden :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'"> -->
        

        <!-- MANAGE ONLY DESKTOP -->
        <!-- <div class="d-flex align-items-center desktopmegoptn">
          <b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
            <v-icon name="file-alt" scale="1.5" class="m-2 text-blue" />
          </b-button>
          <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
            <v-icon name="upload" scale="1.5" class="text-blue"  />
          </b-button>
          <div v-if="user.Variables" class="manageConvoVarDiv">
            <b-dropdown  right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
              <b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div> -->
        <twemoji-textarea 
          :emojiData="emojiDataAll" 
          :emojiGroups="emojiGroups" 
          :skinsSelection="false"
          :searchEmojisFeat="true"
          searchEmojiPlaceholder="Search here."
          searchEmojiNotFound="Emojis not found."
          ref="twemojiTextarea1"
          placeholder="Type a message"
          v-model="message"
          class="twemojiTextarea narrowUI flex-fill"
          @contentChanged="onContentChanged"      
          @keydown.enter.prevent
          @enterKey="send"
          :textareaDisabled="hasCarrierType && this.prospect.CarrierType == 'landline'"
          spellcheck="true"
          title="Emojis">
        </twemoji-textarea>
        <!-- <textarea
          ref="input"
          rows="1"
          class="flex-fill input form-control border mx-1 my-2 p-2"
          placeholder="Type a message"
          v-model="message"
          @keydown.enter.prevent
          @keyup.enter="send"
          spellcheck="true"
          
          v-focus/> -->
        
        <div>
          <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" @click="send" class="p-0 mx-1 my-2 bg-white border primary" title="Send Message">
            <v-icon name="arrow-circle-up" scale="1.5" class="m-2 text-blue" />
          </b-button>
        </div>
        
      </div>
			<div class="border bg-light d-flex align-items-center desktopmegoptn">

				<!-- NARROW BROWSER AND DEVICES -->
				<b-dropdown id="dropdown-md" title="More Options" class="m-md-2 mobilemegoptn">
					<b-dropdown-item>
						<b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
							<v-icon name="file-alt" scale="1.2" class="m-2 text-blue" />
						</b-button>
					</b-dropdown-item>
					<b-dropdown-item v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))">
						<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
							<v-icon name="upload" scale="1.2" class="text-blue"  />
						</b-button>
					</b-dropdown-item>
					<b-dropdown id="dropdown-m" v-if="user.Variables" right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
						<b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
					</b-dropdown>
				</b-dropdown>
				
				<input id="fileUpload" type="file" @change="changeFile($event,'message')" hidden :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'">
				
				<!-- MANAGE ONLY DESKTOP -->
				<div class="d-flex align-items-center desktopmegoptn">
					<b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
						<v-icon name="file-alt" scale="1.5" class="m-2 text-blue" />
					</b-button>
					<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
						<v-icon name="upload" scale="1.5" class="text-blue"  />
					</b-button>
					<div v-if="user.Variables" class="manageConvoVarDiv">
						<b-dropdown  right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
							<b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
						</b-dropdown>
					</div>
				</div>
				<twemoji-textarea 
					:emojiData="emojiDataAll" 
					:emojiGroups="emojiGroups" 
					:skinsSelection="false"
					:searchEmojisFeat="true"
					searchEmojiPlaceholder="Search here."
					searchEmojiNotFound="Emojis not found."
					ref="twemojiTextarea"
					placeholder="Type a message"
					v-model="message"
					class="twemojiTextarea narrowUI flex-fill"
					@contentChanged="onContentChanged"			
					@keydown.enter.prevent
					@enterKey="send"
					:textareaDisabled="hasCarrierType && this.prospect.CarrierType == 'landline'"
					spellcheck="true"
					title="Emojis">
				</twemoji-textarea>
				<!-- <textarea
					ref="input"
					rows="1"
					class="flex-fill input form-control border mx-1 my-2 p-2"
					placeholder="Type a message"
					v-model="message"
					@keydown.enter.prevent
					@keyup.enter="send"
					spellcheck="true"
					
					v-focus/> -->
				
				<div>
					<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" @click="send" class="p-0 mx-1 my-2 bg-white border primary" title="Send Message">
						<v-icon name="arrow-circle-up" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div>
				<div>
					<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" @click="sendAutoMessages" class="p-0 mx-1 my-2 bg-white border primary" title="Generate Message">
						<v-icon name="robot" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div>
				<div v-if="prospect">
					<b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'" @click="$bvModal.show('SchedulerModal')" title="Schedule Message">
						<v-icon name="calendar-alt" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div>
			</div>
			<div id="onlyDesktop1" class="border bg-light d-flex align-items-center"  style="justify-content: space-evenly;">
			<b-dropdown id="dropdown-m" v-if="user.Variables" right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
						<b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
					</b-dropdown>
            <b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
              <v-icon name="file-alt" scale="1.2" class="m-2 text-blue" />
            </b-button>
            <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
              <v-icon name="upload" scale="1.2" class="text-blue"  />
            </b-button>

        <!-- NARROW BROWSER AND DEVICES -->
        <!-- <b-dropdown id="dropdown-md" title="More Options" class="m-md-2 mobilemegoptn">
          <b-dropdown-item>
            <b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
              <v-icon name="file-alt" scale="1.2" class="m-2 text-blue" />
            </b-button>
          </b-dropdown-item>
          <b-dropdown-item v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))">
            <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
              <v-icon name="upload" scale="1.2" class="text-blue"  />
            </b-button>
          </b-dropdown-item>
          <b-dropdown id="dropdown-m" v-if="user.Variables" right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
            <b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
          </b-dropdown>
        </b-dropdown> -->
        
        <input id="fileUpload" type="file" @change="changeFile($event,'message')" hidden :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'">
        

        <!-- MANAGE ONLY DESKTOP -->
        <div class="d-flex align-items-center desktopmegoptn">
          <b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" @click="openTemplateNormal" title="Templates">
            <v-icon name="file-alt" scale="1.5" class="m-2 text-blue" />
          </b-button>
          <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" class="border" @click="chooseFiles" title="Upload Media" >
            <v-icon name="upload" scale="1.5" class="text-blue"  />
          </b-button>
          <div v-if="user.Variables" class="manageConvoVarDiv">
            <b-dropdown  right variant="outline" title="Message Variables" split-variant="outline" text="(X)" class="m-2 btn-outline custom-dropdown" toggle-class="text-blue" style="z-index: 1005">
              <b-dropdown-item :key="v.field" v-for="v in user.Variables" @click="insertVariables(v)">{{v.field}}</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <!-- <twemoji-textarea 
          :emojiData="emojiDataAll" 
          :emojiGroups="emojiGroups" 
          :skinsSelection="false"
          :searchEmojisFeat="true"
          searchEmojiPlaceholder="Search here."
          searchEmojiNotFound="Emojis not found."
          ref="twemojiTextarea"
          
          v-model="message"
          class="twemojiTextarea narrowUI flex-fill"
          
          :textareaDisabled="true"
          spellcheck="true"
          title="Emojis">
        </twemoji-textarea> -->
        <!-- <textarea
          ref="input"
          rows="1"
          class="flex-fill input form-control border mx-1 my-2 p-2"
          disabled
          v-model="message"
          @keydown.enter.prevent
          @keyup.enter="send"
          spellcheck="true"
          
          v-focus/> -->
        
        <!-- <div>
          <b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" @click="send" class="p-0 mx-1 my-2 bg-white border primary" title="Send Message">
            <v-icon name="arrow-circle-up" scale="1.5" class="m-2 text-blue" />
          </b-button>
        </div> -->
				<div>
					<b-button v-if="!hasCarrierType || (hasCarrierType && (this.prospect.CarrierType != 'landline'))" variant="outline" @click="sendAutoMessages" class="p-0 mx-1 my-2 bg-white border primary" title="Generate Message">
						<v-icon name="robot" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div>
				<div v-if="prospect">
					<b-button variant="outline" class="p-0 mx-1 my-2 bg-white border primary" :disabled="hasCarrierType && this.prospect.CarrierType == 'landline'" @click="$bvModal.show('SchedulerModal')" title="Schedule Message">
						<v-icon name="calendar-alt" scale="1.5" class="m-2 text-blue" />
					</b-button>
				</div>
			</div>
		</div>
		<h4 v-else class="centerTextAlign center">Please select a conversation</h4>
		<b-modal id="TemplateModal" size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				Saved Templates
				<b-button  variant="outline" @click="addNewTemplate" class="custom-btn p-0 bg-white border primary" title="Send Message">
				<!-- <v-icon name="arrow-circle-up" scale="1.5" class="m-2 text-blue" /> -->
					Add New
				</b-button>
			</template>
			
			<div v-if="!isShowTemplateList">
				<b-form-group label="Template Name: " class="text-left">
					<b-form-input v-model="templateForm.Name" required />
				</b-form-group>
				<div class="custom-border">
					<b-form-group label="Message: " class="text-left schedule-textbox" style="position:relative;">
					
					<!-- <b-button-group class="w-100">
						<b-button type="button" class="border rounded-top-left flex-fill" variant="outline" @click="addTemplateText('{{firstName}}')">
								First
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="addTemplateText('{{lastName}}')">
								Last
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="addTemplateText('{{email}}')">
								Email
						</b-button>
						<b-button type="button" class="border rounded-top-right flex-fill" variant="outline" @click="addTemplateText('{{number}}')">
								Number
						</b-button>
					</b-button-group> -->

					<b-form-group class="dynamicformdiv">
						<b-form-select v-model="dynamicInsideTags" @change="makeDynamicInsideTags()">
							<b-form-select-option value="">Insert Variable</b-form-select-option>
							
							<option value="firstName">Prospect First Name</option>
							<option value="lastName">Prospect Last Name</option>
							<option value="email">Prospect Email</option>
							<option value="number">Prospect Number</option>

							<option value="OfficeName">Office Name</option>
							<option value="OfficeAddress">Office Address</option>
							
							<option value="ManagerFirstName">Manager First Name</option>
							<option value="ManagerLastName">Manager Last Name</option>
							<option value="ManagerEmail">Manager Email</option>
							<option value="ManagerNumber">Manager Number</option>
							
							<option value="InterviewDate">Interview Date</option>
							<option value="InterviewTime">Interview Time</option>
						
						</b-form-select>
					</b-form-group>

					<input id="fileUploadSch" type="file" @change="changeFile($event,'templateMessage')" hidden>
					<b-button  variant="outline" style="top:93px;" class="border schedule-upload" @click="chooseFilesSch"  >
						<v-icon name="upload" scale="1.3" class="text-blue" />
					</b-button>
					<twemoji-textarea 
						:emojiData="emojiDataAll" 
						:emojiGroups="emojiGroups" 
						:skinsSelection="false"
						:searchEmojisFeat="true"
						searchEmojiPlaceholder="Search here."
						searchEmojiNotFound="Emojis not found."
						ref="templatetwemojiTextarea"
						placeholder="Type a message"
						v-model="templateForm.Body"
						class="twemojiTextarea flex-fill scedule-emoji"
						@contentChanged="onTemplateContentChanged"			
						@keydown.enter.prevent
						spellcheck="true"
						v-focus
						title="Emojis">
					</twemoji-textarea>
					<div class="shiftenter">Press the (Shift + Enter) for new line</div>
					
				</b-form-group>
				<div v-if="hideDiv && messageType == 'templateMessage'" class="border bg-light d-flex align-items-end p-3">
					<div style="position:relative;    display: flex;justify-content: space-between;width: 100%;">
						<!-- <v-icon name="spinner"  scale="1.5" class=" m-2 text-blue" /> -->
						<span v-if="!uplodedFilePath">Loading...</span>
						<a v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<img width="60" :src="uplodedFilePath"/>
						</a>
						<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="music" />
						</a>
						<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="video" />
						</a>
						<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="file" />
						</a>
						<b-button variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
							<v-icon name="times"  scale="1.5" class=" m-2 text-blue" />
						</b-button>
					</div>
					
				</div>
				</div>
				

				<b-button  variant="outline" @click="saveNewTemplate" class="custom-btn custom-save-btn p-0 mx-1 my-2 bg-white border primary" title="Send Message">
					Save Template
				</b-button>
			</div>

			<div v-if="isShowTemplateList" class="w-90 mx-auto">
				<div class="templatesearchbar">
					<b-input type="search" placeholder="Search Templates..." v-model="searchQuery" />
				</div>
			</div>
			
			<b-table-simple v-if="isShowTemplateList" bordered responsive striped hover sticky-header="28em" class="w-90 mx-auto text-left" >
				<b-thead head-variant="light">
					<b-tr class="text-center">
						<b-th>Template Name</b-th>
						<b-th>Message</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr
						class="text-left pointer"
						:key="i"
						v-for="(item,i) in filteredTasks"
						@click="fill(item)">
							<b-td>{{item.Name}}</b-td>
							<b-td>{{item.Message}}
								<!-- <a v-if="item.mediaUrl" class="p-0 mx-1 my-2 primary" style="display:block;text-decoration: none" target="blank"  :href="item.mediaUrl" >
									<v-icon scale="2.5" name="file" />
								</a> -->
								<a v-if="item.mediaUrl"  variant="outline" class="p-0 mx-1 my-2 primary">
									<v-icon scale="2.5" name="file" />
								</a>
							</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-modal>
		<b-modal id="SchedulerModal" hide-footer @hidden="onScheudleModalClose">
			<template v-slot:modal-title>
				Schedule Message
			</template>
			<!-- <b-form> -->
				<!-- <b-form-group label="Campaign Name: " class="text-left">
					<b-form-input
						v-model="form.name"
						required
					/>
				</b-form-group> -->
				

				<b-form-group label="Message: " class="text-left schedule-textbox" style="position:relative;">

					<b-form-group class="dynamicformdiv">
						<b-form-select v-model="dynamicTags" @change="makeDynamicTags()">
							<b-form-select-option value="">Insert Variable</b-form-select-option>
							
							<option value="firstName">Prospect First Name</option>
							<option value="lastName">Prospect Last Name</option>
							<option value="email">Prospect Email</option>
							<option value="number">Prospect Number</option>

							<option value="OfficeName">Office Name</option>
							<option value="OfficeAddress">Office Address</option>
							
							<option value="ManagerFirstName">Manager First Name</option>
							<option value="ManagerLastName">Manager Last Name</option>
							<option value="ManagerEmail">Manager Email</option>
							<option value="ManagerNumber">Manager Number</option>
							
							<option value="InterviewDate">Interview Date</option>
							<option value="InterviewTime">Interview Time</option>
						
						</b-form-select>
					</b-form-group>

					<!-- <b-button-group class="w-100"> -->
						<!-- <b-button type="button" class="border rounded-top-left flex-fill" variant="outline" @click="form.body += '{{firstName}}'">
								First
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="form.body += '{{lastName}}'">
								Last
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="form.body += '{{email}}'">
								Email
						</b-button>
						<b-button type="button" class="border rounded-top-right flex-fill" variant="outline" @click="form.body += '{{number}}'">
								Number
						</b-button> -->
						<!-- <b-button type="button" class="border rounded-top-left flex-fill" variant="outline" @click="addScheduleText('{{firstName}}')">
								First
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="addScheduleText('{{lastName}}')">
								Last
						</b-button>
						<b-button type="button" class="border rounded-0 flex-fill" variant="outline" @click="addScheduleText('{{email}}')">
								Email
						</b-button>
						<b-button type="button" class="border rounded-top-right flex-fill" variant="outline" @click="addScheduleText('{{number}}')">
								Number
						</b-button>
					</b-button-group> -->
					<!-- <b-form-textarea
						class="rounded-bottom border-top-0"
						v-model="form.body"
						no-resize
						required
					/> -->
					<input id="fileUploadSch" type="file" @change="changeFile($event,'scheduleMessage')" hidden>
					<b-button  variant="outline" style="top:93px;" class="border schedule-upload" @click="chooseFilesSch"  >
						<v-icon name="upload" scale="1.3" class="text-blue" />
					</b-button>
					<b-button variant="outline" class="border schedule-upload schedule-upload1" @click="openTemplate" title="Templates">
						<v-icon name="file-alt" scale="1.5" class="m-2 text-blue" />
					</b-button>
					<twemoji-textarea 
						:emojiData="emojiDataAll" 
						:emojiGroups="emojiGroups" 
						:skinsSelection="false"
						:searchEmojisFeat="true"
						searchEmojiPlaceholder="Search here."
						searchEmojiNotFound="Emojis not found."
						ref="scheduletwemojiTextarea"
						placeholder="Type a message"
						v-model="form.body"
						class="twemojiTextarea flex-fill scedule-emoji"
						@contentChanged="onScheduleContentChanged"			
						@keydown.enter.prevent
						spellcheck="true"
						v-focus
						title="Emojis">
					</twemoji-textarea>
					<div class="shiftenter">Press the (Shift + Enter) for new line</div>
					
				</b-form-group>
				<div v-if="hideDiv && messageType == 'scheduleMessage'" class="border bg-light d-flex align-items-end p-3">
					<div style="position:relative;    display: flex;justify-content: space-between;width: 100%;">
						<!-- <v-icon name="spinner"  scale="1.5" class=" m-2 text-blue" /> -->
						<span v-if="!uplodedFilePath">Loading...</span>
						<a v-if="uplodedFilePath && isImage" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<img width="60" :src="uplodedFilePath"/>
						</a>
						<a v-if="uplodedFilePath && isAudio" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="music" />
						</a>
						<a v-if="uplodedFilePath && isVideo" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="video" />
						</a>
						<a v-if="uplodedFilePath && isDocument" style="display:block;text-decoration: none" target="blank"  :href="uplodedFilePath" >
							<v-icon scale="2.5" name="file" />
						</a>
						<b-button variant="outline" class="p-0 mx-1 my-2 primary" @click="removeFile">
							<v-icon name="times"  scale="1.5" class=" m-2 text-blue" />
						</b-button>
					</div>
					
				</div>
				<b-form-group label="Date/Time" class="text-left">
					<b-form-group>
						<b-form-datepicker
							:min="minDate"
							:max="maxDate"
							v-model="form.date"
							size="sm"
							required
							/>
					</b-form-group>
					<b-form-group>
						<b-form-timepicker
							v-model="form.time"
							size="sm"
							required
							/>
					</b-form-group>
				</b-form-group>
				<b-button v-if="!isSending" type="submit" block variant="outline-primary" @click="createCampaignTest">Save Message</b-button>
				<b-button v-if="isSending" type="submit" block variant="outline-primary">Saving... Message</b-button>
			<!-- </b-form> -->
		</b-modal>
	
		<b-modal id="DailerModal" size="sm" hide-footer hide-header centered   no-close-on-esc hide-backdrop no-close-on-backdrop>
			<!-- <template v-slot:modal-title style="padding:5px 20px !important;">
				01:05:22
			</template> -->
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center"  style="align-items:center;width: 100%; justify-content: flex-end;" >
							<span>{{callProspFullName}}</span>
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								
						
								<!-- <button type="button" class="speaker-btn">
									<v-icon name="volume-up" scale="2" class="text-blue" />
								</button> -->
								
								<!-- <button class="menu_btn" type="button">
									<v-icon name="dot-circle" scale="2" class="text-blue" />
								</button> -->
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</b-modal>

		<modal name="my-first-modal" :draggable="true" :clickToClose="false">
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center"  style="align-items:center;width: 100%; justify-content: flex-end;" >
							<span>{{callProspFullName}}</span>
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								
						
								<!-- <button type="button" class="speaker-btn">
									<v-icon name="volume-up" scale="2" class="text-blue" />
								</button> -->
								
								<!-- <button class="menu_btn" type="button">
									<v-icon name="dot-circle" scale="2" class="text-blue" />
								</button> -->
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</modal>
	

		<div v-if="onPhone" class="testmove" ref="someTarget">
			<movable  class="modaltitle " target="someTarget"  >{{callProspFullName}}</movable>
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center" style="align-items:center;width: 100%; justify-content: flex-end;">
							<!-- <span>{{callProspFullName}}</span> -->
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								
						
								<!-- <button type="button" class="speaker-btn">
									<v-icon name="volume-up" scale="2" class="text-blue" />
								</button> -->
								
								<!-- <button class="menu_btn" type="button">
									<v-icon name="dot-circle" scale="2" class="text-blue" />
								</button> -->
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- </movable> -->
		</div>

		<b-modal id="EmailModal" centered  size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				Send Email
				<!-- <b-button class="reply-btn">Reply</b-button> -->
			</template>
			<EmailModal :emailData="emailData" />
		</b-modal>

		<b-modal id="AssEmailModal" hide-footer title="Call Detail" @hidden="onModalHiddenForCallDetail">
			<p>From : <strong> {{callDetailObject.From}} </strong> </p>
			<p>To : <strong> {{callDetailObject.To}} </strong></p>
			<p>Title : 
				<strong v-if="!isEditTitle" style="word-wrap: break-word;">
				{{callDetailObject.Title}}
					<span class="edit-icon" @click="editTitle">
						<v-icon name="pen" scale="1" class="text-blue" />
					</span>
				</strong>
				<b-form-input v-else v-model="editedTitle"></b-form-input>
			</p>
			<p>Notes:
					<strong v-if="!isEditNotes" style="word-wrap: break-word;">
						<span v-html="formatNotes(callDetailObject.Notes)"></span>
						<span class="edit-icon" @click="editNotes">
							<v-icon name="pen" scale="1" class="text-blue" />
						</span>
					</strong>
					<b-form-textarea v-else v-model="editedNotes"></b-form-textarea>
			</p>
			<p v-if="callDetailObject.Duration">Duration:<strong> {{formatDuration(callDetailObject.Duration)}}</strong></p>
			<b-button v-if="isEditTitle" variant="outline-primary" class="mt-4 mb-2" block @click="saveTitleandNotes">Save</b-button>
			<b-button v-if="isEditNotes" variant="outline-primary" class="mt-4 mb-2" block @click="saveTitleandNotes">Save</b-button>
		</b-modal>

		<b-modal id="priorityModal" centered  size="lg" hide-footer>
			<template v-slot:modal-title class="custom-header">
				{{priorityModalData.First}} {{priorityModalData.Last}} Assessment Results
				<!-- <b-button class="reply-btn">Reply</b-button> -->
			</template>
			<PriorityDetailModal :emailData="emailData" :priorityData="priorityModalData" :defaultProfile="defaultProfileData" />
		</b-modal>
		<b-modal id="CallModal" centered  size="custom" dialog-class="my-modal" hide-footer title="Call Details" no-close-on-backdrop no-close-on-esc hide-close hide-on-click-outside>
			<template v-slot:modal-header>
				<h5 class="modal-title">Call Details</h5>
				<button type="button" class="close" @click="onModalHidden">&times;</button>
			</template>
			<form @submit.prevent="submitForm">
			<b-form-group label="Title :" label-cols="4" label-for="title">
			<b-form-input id="title" v-model="callForm.title" required></b-form-input>
			</b-form-group>
			<b-form-group label="Notes :" label-cols="4" label-for="notes">
			<b-form-textarea id="notes" v-model="callForm.notes" rows="4" required></b-form-textarea>
			</b-form-group>
			<b-button type="submit" class="mt-4 mb-2" block variant="outline-primary">Submit</b-button>
		</form>
		</b-modal>
		<!-- <movable class="t	estmove" posTop="444" :grid="20"><span>grid:20</span></movable> -->
	</div>
</template>
<!--<script src="//media.twiliocdn.com/sdk/js/client/v1.4/twilio.min.js"></script>-->
<script>
	import { db,fbstore, sendMessage } from 'src/db'
	import { mapState } from 'vuex';
	import Message from './Message';
	import { TwemojiTextarea } from '@kevinfaguiar/vue-twemoji-picker';
	import  EmojiAllData  from '@kevinfaguiar/vue-twemoji-picker/emoji-data/en/emoji-all-groups.json';
	import EmojiGroups from '@kevinfaguiar/vue-twemoji-picker/emoji-data/emoji-groups.json';
	import axios from "axios";
	import moment from 'moment';
	// import { Twilio }	 from 'twilio'
	// const { Twilio } = require('twilio-client');
	import { Device } from 'twilio-client';
	import EmailModal from "./EmailModal.vue";
	import PriorityDetailModal from "./PriorityDetailModal.vue";

	export default {
        name: "MessageLog",
        props: {
            prospect: Object,
            convo: {
				ClientNumber: String,
				Unread: Number,
				autoSms:Boolean,
				needHumanFeedback:Boolean
			},
            tempConvo: {
				ClientNumber: String,
				Unread: Number,
				autoSms:Boolean,
				needHumanFeedback:Boolean
			}
        },
        components: {
			Message,
			EmailModal,
			PriorityDetailModal,
			'twemoji-textarea': TwemojiTextarea
        },
		computed: {
			filteredTasks () {
				if(this.searchQuery){
					return this.user.Template.filter((item)=>{
						// return item.Message.startsWith(this.searchQuery);
						// return item.Message.toLowerCase().includes(this.searchQuery);
						return item.Message.indexOf(this.searchQuery) > -1 || item.Name.indexOf(this.searchQuery) > -1;
					})
				}else{
					return this.user.Template;
				}
			},
			hasCarrierType() {
				if(this.prospect) {
					return Object.keys(this.prospect).includes('CarrierType');
				}
				return false
			},
			emojiDataAll() {
				return EmojiAllData;
			},
			emojiGroups() {
				return EmojiGroups;
			},
			isDisable() {
				if (this.hasCarrierType) {
					if (this.hasCarrierType && this.prospect.CarrierType == 'mobile') {
						return true;
					}else {
						return false;
					}
				}
				return false;
			},
			minDate() {
				return new Date();
			},
			maxDate() {
				let maxDate = new Date();
				maxDate.setDate(maxDate.getDate() + 365); // Add 365 days to the current date
				return maxDate;
			},
			/*collatedMessages() {
				let all = [...this.messages, ...Object.values(this.sending), ...Object.values(this.failed)];
				if (this.mails.length) {
					all = all.concat(this.mails)
				}
				const AllLength = all.length;
				if(AllLength - (this.OnLoadMsgLimit * this.ScrollCount) > 0) { // 22 - 10*3(30)
					return all.sort((m2, m1) => m2.Date - m1.Date).slice(AllLength - (this.OnLoadMsgLimit * this.ScrollCount), AllLength);
				} else {
					return all.sort((m2, m1) => m2.Date - m1.Date);
				}
			},*/
			collatedMessages() 
			{
				let all = [...this.messages, ...Object.values(this.sending), ...Object.values(this.failed)];
				
				if (this.mails.length) {
					all = all.concat(this.mails)
				}
                if(this.phones.length){
                    all = all.concat(this.phones)
				}

				all = all.sort((m2, m1) => m2.Date - m1.Date);
				
				let ScheduledMsg = this.messages.filter(sm => sm.Scheduled);
				ScheduledMsg.forEach(element3 => {
					const index = all.indexOf(element3);
					if (index > -1) {
						all.splice(index, 1);
					}
				});
				ScheduledMsg = ScheduledMsg.sort((m2, m1) => m2.Date - m1.Date);
				
				var aall = [];
				aall = [...all, ...ScheduledMsg];
				
				let a = Object.assign(all,aall);
				
				//eslint-disable-next-line
				// console.log('a', a);

				const AllLength = a.length;
				if(AllLength - (this.OnLoadMsgLimit * this.ScrollCount) > 0) { // 22 - 10*3(30)
					return a.sort((m2, m1) => m2.Date - m1.Date).slice(AllLength - (this.OnLoadMsgLimit * this.ScrollCount), AllLength);
				} else {
					if(ScheduledMsg.length) {
						return a;
					} else {
						return a.sort((m2, m1) => m2.Date - m1.Date);
					}
				}
			},
			isImage() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.imageFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isAudio() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.audioFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isVideo() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.videoFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isDocument() {
				let value =  false;
				if (this.uplodedFilePath) {
					this.documentFormatArray.forEach(element => {
						if (this.uplodedFilePath.includes(element)) {
							value = true;
						}
					});
				}
				return value
			},
			isOverDue() {
				let val = false;
				let taskType = '';
				let tmpTask = [];
				if(this.prospect && this.prospect.Tasks) {
					for (let task of this.prospect.Tasks) {	
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						taskType = 'gray';
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}else if (task.DueOn && task.Status == 'compeleted') {
							val = false;
							taskType = '';
						}else{
							val = true;
							taskType = 'gray';
						}
						tmpTask.push({ val: val, taskType });
						// tmpTask[tmpTask.length] = taskType;
					}
				}
				const containsRed = tmpTask.some(task => task.taskType === 'red');
				const containsYellow = tmpTask.some(task => task.taskType === 'yellow');
				const containsGray = tmpTask.some(task => task.taskType === 'gray');
				if (containsRed) {
					return { val: true, taskType: 'red' };
				} else if (containsYellow) {
					return { val: true, taskType: 'yellow' };
				} else if (containsGray) {
					return { val: true, taskType: 'gray' };
				} else {
					return { val: false, taskType: '' };
				}
			},
			isOverDueOldCode() {
				let val = false;
				let taskType = '';
				let tmpTask = [];
				if(this.prospect && this.prospect.Tasks) {
					for (let task of this.prospect.Tasks) {
						var date_3_day = new Date();
						date_3_day.setDate(date_3_day.getDate() + 3);
						// var date_1_day = new Date();
						// date_1_day.setDate(date_1_day.getDate() + 1);
						var end = new Date();
						end.setHours(23,59,59,999);
						taskType = 'gray';
						if (task.DueOn && task.Status == 'draft' && (this.isToday(new Date(task.DueOn)))) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now())) {
							taskType = 'red'
							val = true;
						}else if (task.DueOn && task.Status == 'draft' && (task.DueOn < (date_3_day.getTime()) && task.DueOn > (end.getTime()))) {
							val = true;
							taskType = 'yellow';
						}else if (task.DueOn && task.Status == 'compeleted') {
							val = false;
							taskType = '';
						}else{
							val = true;
							taskType = 'gray';
						}
						tmpTask[tmpTask.length] = taskType;
					}
				}
				if(tmpTask.includes('red')) {
					return {val,taskType:"red"}		
				}else if(tmpTask.includes('yellow')) {
					return {val,taskType:"yellow"}
				}else{
					return {val,taskType}
				}
			},
			TaskList() {
				let unCompeletedTaskList = [];
				for (let task of this.prospect.Tasks) {
					var someDate = new Date();
					someDate.setDate(someDate.getDate() + 3);
					// if (task.DueOn && task.Status == 'draft' && ((task.DueOn <= (someDate.getTime()) && task.DueOn >=  Date.now() || task.DueOn <= Date.now()))) {
					// 	unCompeletedTaskList.push(task)
					// }
					// unCompeletedTaskList.push(task)
					if (task.DueOn && task.Status == 'draft') {
						unCompeletedTaskList.push(task)
					}
				}
				return unCompeletedTaskList;
			},
			getId() {
				return  "test_"+this.prospect.id;
			},
			getClassName() {
				let cname = '';
				if (this.isOverDue.taskType == 'yellow') {
					cname = 'yellow'
				}else if(this.isOverDue.taskType == 'gray') {
					cname = 'gray'
				}else if (this.isOverDue.taskType == 'red') {
					cname = 'red'
				}
				return cname;
			},
			...mapState('globals', ['activeConvo', 'activeProsp','startCount','unreadCountTotal','autopilotCountTotal']),
			...mapState('firebase', ['user', 'messages','mails','phones'])
		},
        methods: {
			onScheudleModalClose(){
				this.uplodedFilePath = "";
				this.hideDiv = false;
			},
			formatNotes(notes) {
				if (!notes) return notes;
				const urlRegex = /(https?:\/\/[^\s]+)/g;
				return notes.replace(urlRegex, '<a href="$1" target="_blank">$1</a>');
			},
			onModalHiddenForCallDetail(){
				this.isEditTitle = false;
				this.isEditNotes = false;
			},
			onModalHidden(){
				let cd='';
				let dir='';
				if(localStorage.getItem('callDuration')){ 
					cd=localStorage.getItem('callDuration');
				}
				if(localStorage.getItem('Direction')){
					dir=localStorage.getItem('Direction');
				}
				let formData = {
					From: this.user.Twilio,
					ProspectID: this.prospect.id,
					Uid: this.user.Uid,
					To: this.callProspNumber,
					Title: "Call",
					Notes: "",
					RecordingPath: '',
					Duration:parseFloat(cd),
					Inbound: dir == "OUTGOING" ? false :true
				}
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/CallsPhones", formData);
				this.$bvModal.hide('CallModal');
				this.callForm.title = '';
				this.callForm.notes = '';
				localStorage.removeItem('Direction');
				localStorage.removeItem('callDuration');
			},
			async saveTitleandNotes() {
				if(this.isEditTitle){
					this.callDetailObject.Title=this.editedTitle;
					let callRef=await db.collection('Calls').where('ProspectID','==',`${this.prospect.id}`).get();
					let messageList = callRef.docs.map((doc) => {
						let data = {id:doc.id};
						return data;
					});
					let phoneDocRef=await db.collection(`Calls/${messageList[0].id}/Phones`).doc(this.callDetailObject.id);
					phoneDocRef.update({Title:this.editedTitle});
					this.isEditTitle = false;
				}
				else if(this.isEditNotes){
					this.callDetailObject.Notes = this.editedNotes;
					let callRef=await db.collection('Calls').where('ProspectID','==',`${this.prospect.id}`).get();
					let messageList = callRef.docs.map((doc) => {
						let data = {id:doc.id};
						return data;
					});
					let phoneDocRef=await db.collection(`Calls/${messageList[0].id}/Phones`).doc(this.callDetailObject.id);
					phoneDocRef.update({Notes:this.editedNotes});
					this.isEditNotes = false;
				}
			},
			editTitle(){
				this.isEditTitle=true;
				this.isEditNotes=false;
				this.editedTitle=this.callDetailObject.Title;
			},
			editNotes(){
				this.isEditNotes=true;
				this.isEditTitle=false;
				this.editedNotes=this.callDetailObject.Notes;
			},
			editMessage(message,rating) {
				this.tempMsgForEdit=message;
				this.rating=rating;
				this.addTextForEdit(message.Body);
			},
			async deleteMessage(message,rating) {
				this.rating=rating;
				let autoMessageDB={
					Message:message.Body,
					Rating:this.rating,
					Date:Date.now(),
					Uid:this.user.Uid
				}
				if(this.testAutoConvotemp && this.testAutoConvotemp.Body==message.Body){
					this.message = "";
					this.cleanText();
					this.$delete(this.testAutoConvotemp.sending,this.testAutoConvotemp.id);
                    if(this.rating){await db.collection('Generated').add(autoMessageDB);}
				}
			},
			formatDuration(duration) {
				const hours = Math.floor(duration / 3600);
				const minutes = Math.floor((duration % 3600) / 60);
				const seconds = Math.round(duration % 60);			
				return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
			},
			openProspectDetails() {
				var ml = document.getElementById("MessageLog");
				if(ml) { ml.style.zIndex ="0"; }
				var ml2 = document.getElementById("Prospect");
				if(ml2) { ml2.style.zIndex ="1001"; }
			},
			// MANAGE DYNAMIC TAGS
			makeDynamicTags() {
				if(this.dynamicTags) {
					this.$refs.scheduletwemojiTextarea.addText(`{{${this.dynamicTags}}}`);
				}
			},
			makeDynamicInsideTags() {
				if(this.dynamicInsideTags) {
					this.$refs.templatetwemojiTextarea.addText(`{{${this.dynamicInsideTags}}}`);
				}
			},
			// load more Message in chat while scrolling
			OnScroll() {
				let component = this.$refs.messageLog;
				if(component && component.scrollTop == 0) {
					this.ScrollCount++;
					this.collatedMessages;
					this.$refs.messageLog.scrollTop = 1;
				}
			},
			createCampaign() {
				if (!this.form.body && !this.uplodedFilePath) {
					alert('Please enter message content');
					return
				}
				if (!this.form.date || !this.form.time) {
					alert('Please select date and time');
					return
				}
				let ms = new Date(`${this.form.date} ${this.form.time}`).valueOf();
				if (ms < this.minDate || ms > this.maxDate) {
					alert("Sheduled Date/Time is either in the past or further than 30 days in the future");
					return;
				}
				this.isSending = true;
				const smsData = {
					pid:this.user.id,
					cid:this.activeProsp,
					body:this.form.body,
					SendOn:ms,
					mediaUrl:this.uplodedFilePath,
				};
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/automatedSms", smsData)
				.then(response => {
					// eslint-disable-next-line
					console.log(response);
					this.isSending = false;
					this.form = {};
					this.$bvModal.hide('SchedulerModal');
				}).catch(err => alert(`Failure scheduling message: ${err}`));
				// scheduleCampaign({
				// 	Name: this.form.name,
				// 	Recipients: [this.prospect.id],
				// 	Body: this.form.body,
				// 	DateTime: ms
				// })
				// .then(() => alert(`Message has been scheduled for ${this.$parseDate(ms)}`))
				// .catch(err => alert(`Failure scheduling message: ${err.response.data.message}`));
				// this.form = {};
				
			},
			createCampaignTest() {
				if (!this.form.body && !this.uplodedFilePath) {
					alert('Please enter message content');
					return
				}
				if (!this.form.date || !this.form.time) {
					alert('Please select date and time');
					return
				}
				let ms = new Date(`${this.form.date} ${this.form.time}`).valueOf();
				if (ms < this.minDate || ms > this.maxDate) {
					alert("Sheduled Date/Time is either in the past or further than 30 days in the future");
					return;
				}
				this.isSending = true;
				const smsData = {
					pid:this.user.id,
					cid:this.activeProsp,
					body:this.form.body,
					SendOn:ms,
					mediaUrl:this.uplodedFilePath,
				};
				//eslint-disable-next-line
				console.log('smsData', smsData);
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/automatedSms", smsData)
				.then(response => {
					// eslint-disable-next-line
					console.log(response);
					this.isSending = false;
					this.form = {};
					this.dynamicTags = '';
					this.$bvModal.hide('SchedulerModal');
					this.removeFile();
				}).catch(err => {
					this.removeFile();
					alert(`Failure scheduling message: ${err}`);
				});
				// scheduleCampaign({
				//  Name: this.form.name,
				//  Recipients: [this.prospect.id],
				//  Body: this.form.body,
				//  DateTime: ms
				// })
				// .then(() => alert(`Message has been scheduled for ${this.$parseDate(ms)}`))
				// .catch(err => alert(`Failure scheduling message: ${err.response.data.message}`));
				// this.form = {};
				
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			onContentChanged(c) {
				if(c === '<br>'){
					this.cleanText();
				}
				this.message = c;
			},
			cleanText() {
				this.$refs.twemojiTextarea.cleanText();
				this.$refs.twemojiTextarea1.cleanText();
			},
			addText(text) {
				this.$refs.twemojiTextarea.addText(text);
				this.$refs.twemojiTextarea1.addText(text);
			},
			addTextForEdit(text) {
				this.message = '';
				this.$refs.twemojiTextarea.addText(text);
				this.$refs.twemojiTextarea1.addText(text);
				this.message=text;
				this.isEditable=true;
			},
			addScheduleText(text) {
				this.$refs.scheduletwemojiTextarea.addText(text);
			},
			async send(event) {
				if(!this.convo){
					this.localConvo = this.tempConvo;
				}else{
					this.localConvo = this.convo;
				}
				// eslint-disable-next-line
				console.log('convo', this.localConvo);
				if(!this.localConvo){
					let convoSnap = await db.collection('Conversations')
						.where('ClientNumber', '==', this.prospect.Number)
						.where('Uid', '==', this.user.Uid)
						.orderBy('DateUpdated', 'desc')
						.get();
					let convoData = convoSnap.docs.map(doc => ({
						id: doc.id, 
						...doc.data(),
					}));
					// eslint-disable-next-line
					console.log('convoSnap', convoData);
					this.localConvo = convoData[0];
				}
				if(this.isEditable){
                if(this.prospect.hasOwnProperty('Number') && this.prospect.Number) {			
				if (this.prospect.hasOwnProperty('Status') && this.prospect.Status == "Archived") {
					alert('Archived prospects can not be messaged.');
					return;
				}
				if (event.shiftKey) {
					this.message += '\n';
					return;
				}
				if (this.message == "" && this.uplodedFilePath == '') {
					return;
				}
				let body = this.message, id = Object.keys(this.sending).length, date = new Date();
				this.message = "";
				this.cleanText();
				this.$delete(this.testAutoConvotemp.sending,this.testAutoConvotemp.id);
				this.$set(this.sending, id, {Body: body, Date: date, Incoming: false, Status: 'Sending'});
				sendMessage({
					To: this.localConvo.ClientNumber,
					Body: body,
					mediaUrl:this.uplodedFilePath,
					Uid:this.localConvo.Uid
				})
				.catch(() => {
					this.uplodedFilePath = '';
					this.hideDiv = false;
					this.$set(this.failed, id, {Body: body, Date: date, Incoming: false, Status: 'Failed'});
				})
				.finally(async() => {
					this.uplodedFilePath = '';
					this.hideDiv = false;
					let autoMessageDB={
							Message:body,
							Rating:this.rating,
							Date:Date.now(),
							Uid:this.user.Uid
						}	
					await db.collection('Generated').add(autoMessageDB);
					// this.message.Auto=false;
					this.$delete(this.sending, id);
					this.isEditable=false;
				})
				} else {
					alert("Must add a phone number to send and receive text messages.");
				}
				}else{
				if(this.prospect.hasOwnProperty('Number') && this.prospect.Number) {
				if (this.prospect.hasOwnProperty('Status') && this.prospect.Status == "Archived") {
					alert('Archived prospects can not be messaged.');
					return;
				}
				if (event.shiftKey) {
					this.message += '\n';
					return;
				}
				if (this.message == "" && this.uplodedFilePath == '') {
					return;
				}
				let body = this.message, id = Object.keys(this.sending).length, date = new Date();
				this.message = "";
				this.cleanText();
				this.$set(this.sending, id, {Body: body, Date: date, Incoming: false, Status: 'Sending'});
				sendMessage({
					To: this.localConvo.ClientNumber,
					Body: body,
					mediaUrl:this.uplodedFilePath,
					Uid:this.localConvo.Uid
				})
				.catch(() => {
					this.uplodedFilePath = '';
					this.hideDiv = false;
					this.$set(this.failed, id, {Body: body, Date: date, Incoming: false, Status: 'Failed'});
				})
				.finally(() => {
					this.uplodedFilePath = '';
					this.hideDiv = false;
					this.$delete(this.sending, id);
				})
				} else {
					alert("Must add a phone number to send and receive text messages.");
				}
				}
			},
			sendAutoMessages() {
				this.activeConvoTemp=this.activeConvo;
                if(this.user.Uid && this.prospect.hasOwnProperty('Number') && this.prospect.Number){
				if (this.prospect.hasOwnProperty('Status') && this.prospect.Status == "Archived") {
					alert('Archived prospects can not be messaged.');
					return;
				}
				const hasAutoMessage = Object.values(this.sending).some(message => message.Auto === true);
				if(hasAutoMessage){
					return;
				}
				this.showLoader=true;
				axios.post('https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/generateMessage',{
					Uid : this.user.Uid,
					prospectNumber : this.prospect.Number
				}).then(res=>{
					this.message=res.data.openAiMessage;
					this.showLoader=false;
				if(res && res.data.openAiMessage){
				if(this.activeConvo == this.convo.id){
                let body = this.message, id = Object.keys(this.sending).length, date = new Date();
				this.message = "";
				this.cleanText();
				this.$set(this.sending, id, {Body: body, Date: date, Incoming: false,Auto :true});
				let testAutoConvo={
					body:body,
					id:id,
					date:date,
					To: this.convo.ClientNumber,
					Body: body,
					mediaUrl:this.uplodedFilePath,
					Uid:this.convo.Uid,
					sending:this.sending
				};
                this.testAutoConvotemp=testAutoConvo;
				this.$emit('testAutoConvo', testAutoConvo);
				}
				}})
			}
			},
			resendError(message) {
				let current, id;
				for (id in this.failed) {
					current = this.failed[id];
					if (current.Date == message.Date && current.Body == message.Body) {
						this.$delete(this.failed, id);
						break;
					}
				}
				id = Object.keys(this.sending).length;
				this.$set(this.sending, id, {Body: current.Body, Date: current.Date, Incoming: false, Status: 'Sending'});
				sendMessage({
					To: this.convo.ClientNumber,
					Body: current.Body,
					mediaUrl:this.uplodedFilePath,
					Uid:this.convo.Uid
				})
				.catch(() => {
					this.$set(this.failed, id, {Body: current.Body, Date: current.Date, Incoming: false, Status: 'Failed'});
				})
				.finally(() => {
					this.$delete(this.sending, id);
				})
			},
			deleteError(message) {
				let current;
				for (let id in this.failed) {
					current = this.failed[id];
					if (current.Date == message.Date && current.Body == message.Body) {
						this.$delete(this.failed, id);
						break;
					}
				}
			},
			fill(item) {
				if (this.$refs.twemojiTextarea) {
					this.$refs.twemojiTextarea.cleanText();
					this.removeFile();
				}
				if (this.$refs.twemojiTextarea1) {
					this.$refs.twemojiTextarea1.cleanText();
					this.removeFile();
				}
				let message = item.Message
				if (item && item.hasOwnProperty('mediaUrl') && item.mediaUrl) {
					this.uplodedFilePath = item.mediaUrl;
					this.hideDiv = true;
				}
				if (this.prospect) {

					let officeName = '';
					let officeAddress = '';
					let mergeOfficeAddress = '';
					let managerFirstName = '';
					let managerLastName = '';
					let managerEmail = '';
					let managerNumber = '';
					
					if(this.user.Offices) {
						let getOfficeData = this.user.Offices.find(um => um.OfficeId === this.prospect.Office);
						if(getOfficeData) {
							// OFFICE DATA
							officeName = getOfficeData.OfficeName ? getOfficeData.OfficeName: '';
							officeAddress = getOfficeData.StreetAddress ? getOfficeData.StreetAddress : '';
							let officeCity = getOfficeData.City ? getOfficeData.City : '';
							let officeState = getOfficeData.State ? getOfficeData.State : '';
							let officeZipCode = getOfficeData.ZipCode ? getOfficeData.ZipCode : '';
							mergeOfficeAddress = `${officeAddress} ${officeCity} ${officeState} ${officeZipCode}`;
							// MANAGER DATA
							if(getOfficeData.MgrID) {
								let managerData = this.user.Managers.find(um1 => um1.MgrID === getOfficeData.MgrID);
								if (managerData) {
									managerFirstName = managerData.First ? managerData.First : '';
									managerLastName = managerData.Last ? managerData.Last : '';
									managerEmail = managerData.Email ? managerData.Email : '';
									if(managerData.Number) {
										managerNumber = this.$parseNumber(managerData.Number)
									}
								}
							}
						}
					}

					// PROSPECT
					let edited = message.replace(/{{firstName}}/g, this.prospect.First ? this.prospect.First : '');
					edited = edited.replace(/{{lastName}}/g, this.prospect.Last ? this.prospect.Last : '');
					edited = edited.replace(/{{email}}/g, this.prospect.Email ? this.prospect.Email : '');
					edited = edited.replace(/{{number}}/g, this.$parseNumber(this.prospect.Number));

					if(this.prospect.hasOwnProperty('Interviewed') && this.prospect.Interviewed) {
						let InterviewDateTimezoneWise;
						let getTimeZoneDetails = '';
						if(this.user.hasOwnProperty('TimeZone')) {
							let getUserTimezone = this.user.TimeZone;
							let getInterviewTimeData = this.prospect.Interviewed;
							var datea = new Date(getInterviewTimeData);
							var Pacific, Mountain, Central, Eastern;
							if(getUserTimezone == 0) {
								Pacific = datea.toLocaleString('en-US', { timeZone: 'Canada/Pacific', });
								InterviewDateTimezoneWise = moment(Pacific).valueOf();
								getTimeZoneDetails = "Pacific Time";
							}
							if(getUserTimezone == 1) {
								Mountain = datea.toLocaleString('en-US', { timeZone: 'Canada/Mountain', });
								InterviewDateTimezoneWise = moment(Mountain).valueOf();
								getTimeZoneDetails = "Mountain Time";
							}
							if(getUserTimezone == 2) {
								Central = datea.toLocaleString('en-US', { timeZone: 'Canada/Central', });
								InterviewDateTimezoneWise = moment(Central).valueOf();
								getTimeZoneDetails = "Central Time";
							}
							if(getUserTimezone == 3) {
								Eastern = datea.toLocaleString('en-US', { timeZone: 'Canada/Eastern', });
								InterviewDateTimezoneWise = moment(Eastern).valueOf();
								getTimeZoneDetails = "Eastern Time";
							}
							// eslint-disable-next-line
							// console.log('currrent Pacific Time', Pacific);
							// eslint-disable-next-line
							// console.log('currrent Pacific Time Epoch', moment(Pacific).valueOf());
						}
						edited = edited.replace(/{{InterviewDate}}/g, moment.unix(InterviewDateTimezoneWise)._isValid ? moment(InterviewDateTimezoneWise).format('MM-DD-YYYY') : ''); 
						edited = edited.replace(/{{InterviewTime}}/g, moment.unix(InterviewDateTimezoneWise)._isValid ? `${moment(InterviewDateTimezoneWise).format('hh:mm A')} ${getTimeZoneDetails}` : ''); 
					} else {
						edited = edited.replace(/{{InterviewDate}}/g, ''); 
						edited = edited.replace(/{{InterviewTime}}/g, ''); 
					}

					// OFFICE
					edited = edited.replace(/{{OfficeName}}/g, officeName);
					edited = edited.replace(/{{OfficeAddress}}/g, mergeOfficeAddress);

					// MANAGER
					edited = edited.replace(/{{ManagerFirstName}}/g, managerFirstName);
					edited = edited.replace(/{{ManagerLastName}}/g, managerLastName);
					edited = edited.replace(/{{ManagerEmail}}/g, managerEmail);
					edited = edited.replace(/{{ManagerNumber}}/g, managerNumber);

					if (this.isScheduleTemplate) {
						this.form.body = edited;
					}else {
						this.message = edited;
					}
					this.$bvModal.hide('TemplateModal');
				}
				else {
					this.message = message;
					this.form.body = message;
					this.$bvModal.hide('TemplateModal');
				}
				if (this.isScheduleTemplate) {
					this.messageType = 'scheduleMessage';
					this.addScheduleText(this.form.body);
				}else {
					this.addText(this.message);
				}
				this.isScheduleTemplate = false;
			},
			showTemps() { this.temps = true },
			hideTemps() { this.temps = false },
			showSched() { this.sched = true },
			hideSched() { this.sched = false },
			changeFile(event,type) {
				this.messageType = type;
				this.uploadValue = 0;
				this.uplodedFilePath = '';
				this.fileData = event.target.files[0];
				if (typeof this.fileData !== "undefined") {
					const allowedExtensions = ['image/jpeg', 'image/png', 'image/gif'];
					if (allowedExtensions.includes(this.fileData.type)) {
					if (this.fileData.size <= 5242880) { // 5MB in bytes
						this.hideDiv = true;
						this.onUpload();
						}
					else {
						alert('Image files (jpg, png, gif) must be less than 5MB');
					}
					}else if (this.supportedType.includes(this.fileData.type)) {
					if (this.fileData.size < 1048576) {
						this.hideDiv = true;
						this.onUpload();
					}else {
						alert('File size must be less than 1MB');
					}
					}else {
					alert('This format is not allow to send message');
					}
				}
			},
			onUpload(){
				this.uplodedFilePath = '';
				const storageRef = fbstore.ref(`${this.fileData.name}`).put(this.fileData);
				storageRef.on(`state_changed`,snapshot=>{
					this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
				}, error=>{
					//eslint-disable-next-line
					console.log(error.message)
				},
				()=>{this.uploadValue=100;
					storageRef.snapshot.ref.getDownloadURL().then((url)=>{
						this.uplodedFilePath = url;
						// this.message = "";
						// this.send({});
					});
				});
			},
			chooseFiles() {
				document.getElementById("fileUpload").click()
			},
			chooseFilesSch() {
				document.getElementById("fileUploadSch").click()
			},
			removeFile() {
				this.uplodedFilePath = '';
				this.hideDiv = false;
			},
			insertVariables(v) {
				this.addText(v.value)
			},
			startMessage() {
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:true});
				this.$store.dispatch('firebase/rebindConvosStarredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			unStartMessage() {
				db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Starred:false});
				this.$store.dispatch('firebase/rebindConvosStarredCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			cancelClick() {
				this.$emit('showLoader');
			},
			onScheduleContentChanged(c) {
				this.form.body = c;
			},
			openTemplate() {
				this.isScheduleTemplate = true;
				this.isShowTemplateList = true;
				this.$bvModal.show('TemplateModal')
			},
			openTemplateNormal() {
				this.isScheduleTemplate = false;
				this.isShowTemplateList = true;
				this.$bvModal.show('TemplateModal')
			},
			// Handle muting
			toggleMute() {
				this.muted = !this.muted;
				Device.activeConnection().mute(this.muted);
			},
			toggleCall: function() {
				if (!this.onPhone) {
					this.muted = false;
					this.onPhone = true;
					// make outbound call with current number
					// var n = '+' + this.countryCode + this.currentNumber.replace(/\D/g, '');
					this.connection = Device.connect({ number: this.callProspNumber,callerID:this.user.Twilio });
					let newCallList = [];
					if (this.prospect.Calls) {
						newCallList = this.prospect.Calls;
					}
					newCallList.push({
							DateTime:Date.now(),
							Direction:'Outgoing',
							Duration:'',
							Status:'Completed',
					});
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update({Calls:newCallList});
					// setInterval(function(){
					// 	//eslint-disable-next-line
					// 	console.log('hehehehehhe');
					// }, 3000);
					setTimeout(() => {
						this.toggleCall()
					}, 3600000);
				} else {
					// hang up call in progress
					Device.disconnectAll();
					// this.$bvModal.hide('DailerModal');
					// this.$modal.hide('my-first-modal');
				}
			},
			makeCallClick() {
				if(this.prospect.hasOwnProperty('Number') && this.prospect.Number) {
				if (confirm("Are you sure you want to call this prospect?")) {
					this.callProspFullName = this.$parseAlias(this.prospect);
					this.callProspNumber = this.prospect.Number;
					// this.$bvModal.show('DailerModal');
					// this.$modal.show('my-first-modal');
					// this.toggleCall();
					// this.onPhone = true;
					let callDetailsObject = {
						showCallBox:true,
						ProspName:this.callProspFullName,
						ProspNumber:this.callProspNumber
					}
					this.$emit('getCallDetails',callDetailsObject);
					// this.$emit('changeUser',this.callProspFullName);
					
				}
				} else {
					alert("Must add an phone number to initiate a call.");
				}
				// makeCall()
				// .then((res) => {
				// 	//eslint-disable-next-line
				// 	console.log(res);
				// })
				// .catch(err => {
				// 	//eslint-disable-next-line
				// 	console.log(err);
				// });
			},
			addNewTemplate() {
				this.isShowTemplateList = false;
			},
			addTemplateText(text) {
				this.$refs.templatetwemojiTextarea.addText(text);
			},
			onTemplateContentChanged(c) {
				this.templateForm.Body = c;
			},
			saveNewTemplate() {
				if (this.templateForm.Name || this.templateForm.Body) {
					let isTemplateExist = false;
					for (let temp of this.user.Template) {
						if (this.templateForm.Name == temp.Name) {
							temp.Message = this.templateForm.Body
							isTemplateExist = true;
						}
					}
					if (!isTemplateExist) {
						let newAddedTemplate = [];
						newAddedTemplate = this.user.Template;
						newAddedTemplate.push({
							Name:this.templateForm.Name,
							Message:this.templateForm.Body,
							mediaUrl:this.uplodedFilePath
						});
					}
					//eslint-disable-next-line
					// console.log(this.user.Template);
					this.cleanTemplateText();
					this.templateForm.Name = '';
					this.templateForm.Body = '';
					this.uplodedFilePath = '';
					this.hideDiv=false,
					db.doc(`Users/${this.user.id}`).update({ Template: this.user.Template });
					this.isShowTemplateList = true;
				}else {
					alert('Please add name or body');
				}
			},
			cleanTemplateText() {
				this.$refs.templatetwemojiTextarea.cleanText();
			},
			openEmailModal(message,type) {
				let emailDetailsObject = {
						user:this.user,
						prospect:this.prospect,
						message:message,
						type:type
					}
				this.emailData = emailDetailsObject;
				
				if(this.prospect.hasOwnProperty('Email') && this.prospect.Email) {
					this.$bvModal.show('EmailModal');
				} else {
					alert("Must add an email address to send and receive emails.");
				}

			},
			openCallModal(message,type) {
				let callDetailsObject = {
						user:this.user,
						prospect:this.prospect,
						message:message,
						type:type
					}
				//eslint-disable-next-line
				console.log("callDetailsObject",callDetailsObject);	
				this.callDetailObject = message;
				
				if(this.prospect.hasOwnProperty('Number') && this.prospect.Number) {
					this.$bvModal.show('AssEmailModal');
				} else {
					alert("Must add a number.");
				}

			},
			calculatePriority(data) {
				let val = 0;
				let pf,pfid;
				if (this.user.hasOwnProperty('CciProfiles') && this.user.CciProfiles) {
					let defaultProfile =  this.user.CciProfiles.find(cp => cp.Default == true);
					//eslint-disable-next-line
					// console.log('defaultProfile', defaultProfile);
					if (defaultProfile) {
						if (
							(data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) &&
							(data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper) 
						) {
							val = 1;
						} else if (
							((data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
							(data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
							(data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
							(data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) )||
							((data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
							(data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
							(data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
							(data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
							(data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
							(data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper))
						) {
							val = 2;
						}else if (
							((data.Builder <= defaultProfile.BuilderLower || data.Builder >= defaultProfile.BuilderUpper) ||
							(data.Merchant <= defaultProfile.MerchantLower || data.Merchant >= defaultProfile.MerchantUpper) ||
							(data.Innovator <= defaultProfile.InnovatorLower || data.Innovator >= defaultProfile.InnovatorUpper) || 
							(data.Banker <= defaultProfile.BankerLower || data.Banker >= defaultProfile.BankerUpper) ) &&
							((data.Intuitive <= defaultProfile.IntuitiveLower || data.Intuitive >= defaultProfile.IntuitiveUpper) ||
							(data.Cognitive <= defaultProfile.CognitiveLower || data.Cognitive >= defaultProfile.CognitiveUpper) ||
							(data.Practical <= defaultProfile.PracticalLower || data.Practical >= defaultProfile.PracticalUpper) ||
							(data.Creative <= defaultProfile.CreativeLower || data.Creative >= defaultProfile.CreativeUpper) ||
							(data.Independent <= defaultProfile.IndependentLower || data.Independent >= defaultProfile.IndependentUpper) || 
							(data.Community <= defaultProfile.CommunityLower || data.Community <= defaultProfile.CommunityUpper))
						) {
							val = 3;
						}
						pf = defaultProfile.Name;
						pfid = defaultProfile.ProfileId;
					}else {
						val = 0;
						pf = '';
						pfid = ''
					}
				}
				return { val, pf, pfid };
			},
			UpdatePriorityData()
			{
				var currentProspectData = this.prospect.CciMap;
				
				let ff1 = {
					cciMap1:{
						DateSubmitted:Date.now(),
						Builder:currentProspectData.Builder,
						Merchant:currentProspectData.Merchant,
						Innovator:currentProspectData.Innovator,
						Banker:currentProspectData.Banker,
						Intuitive:currentProspectData.Builder+currentProspectData.Merchant,
						Cognitive:currentProspectData.Innovator+currentProspectData.Banker,
						Practical:currentProspectData.Builder+currentProspectData.Banker,
						Creative:currentProspectData.Merchant+currentProspectData.Innovator,
						Independent:currentProspectData.Builder+currentProspectData.Innovator,
						Community:currentProspectData.Banker+currentProspectData.Merchant,
					}
				}

				let pdata  = this.calculatePriority(ff1.cciMap1);
				// var aPriority = pdata.val;
				// var bProfileName = pdata.pf;
				// var cProfileId = pdata.pfid;

				this.priorityModalData.CciMap['Priority'] = pdata.val;

				// UPDATE PRIORITY VALUE
				let updatedPriority = { 'CciMap.Priority': pdata.val }
				db.doc(`Users/${this.user.id}/Prospects/${this.priorityModalData.id}`).update(updatedPriority);

			},
			openPriorityModal(message,type) {
				let emailDetailsObject = {
						user:this.user,
						prospect:this.prospect,
						message:message,
						type:type
					}
				this.emailData = emailDetailsObject;
				this.priorityModalData = this.prospect;
				let abc =  this.user.CciProfiles.find(cp => cp.Default == true);
				this.UpdatePriorityData();
				//eslint-disable-next-line
				//console.log('abc1', abc);
				if (abc) {
					this.defaultProfileData = abc;
				}else {
					this.defaultProfileData = {}
				}
				this.$bvModal.show('priorityModal');
			},
			submitForm() {
				let cd='';
				let dir='';
				if(localStorage.getItem('callDuration')){ 
					cd=localStorage.getItem('callDuration');
				}
				if(localStorage.getItem('Direction')){
					dir=localStorage.getItem('Direction');
				}
				let formData = {
					From: this.user.Twilio,
					ProspectID: this.prospect.id,
					Uid: this.user.Uid,
					To: this.callProspNumber,
					Title: this.callForm.title,
					Notes: this.callForm.notes,
					RecordingPath: '',
					Duration:parseFloat(cd),
					Inbound: dir == "OUTGOING" ? false :true
				}
				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/CallsPhones", formData);
				this.$bvModal.hide('CallModal');
				this.callForm.title = '';
				this.callForm.notes = '';
				localStorage.removeItem('Direction');
				localStorage.removeItem('callDuration');
			},
			updateAutoSms(event){
				let eve = event;
				if(eve === true){
					this.$store.commit('globals/SET', { var: 'autopilotCountTotal', val: this.autopilotCountTotal+1 });
				}else{
					this.$store.commit('globals/SET', { var: 'autopilotCountTotal', val: this.autopilotCountTotal-1 });
				}
				if (this.convo) {
					db.doc(`Conversations/${this.convo.id}`).update({autoSms: eve});
				}
				this.$store.dispatch('firebase/rebindConvosAutopilotCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			},
			updateNeedHumanNeeded(){
				if (this.convo && this.convo.needHumanFeedback) {
					db.doc(`Conversations/${this.convo.id}`).update({needHumanFeedback: false});
				}
				this.$store.dispatch('firebase/rebindConvosFeedbackCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			}
        },
        watch: {
			// message: {
			// 	/* this handler controls the growth of the input text-area */
			// 	handler() {
			// 		setTimeout(() => {
			// 			this.$refs.input.rows = 1;
			// 			while (this.$refs.input.scrollHeight > this.$refs.input.offsetHeight && this.$refs.input.rows < 4) {
			// 				this.$refs.input.rows += 1;
			// 				this.$refs.messageLog.scrollTop = this.$refs.messageLog.scrollHeight;
			// 			}
			// 		})
			// 	}
			// },
			messages: {
				immediate: true,
				handler() {
					this.$emit('open', 'prosp');
					this.$nextTick(() => {
						if (this.$refs.messageLog) {
							this.$refs.messageLog.scrollTop = this.$refs.messageLog.scrollHeight;
							this.ScrollCount = 1;
						} 
					})
				}
			},
        },
        data() {
            return {
				isEditable:false,
				rating:null,
				activeConvoTemp:'',
				showLoader:false,
				testAutoConvotemp:{},
				tempMsgForEdit:{},
				editedTitle:'',
				editedNotes:'',
				isEditTitle:false,
				isEditNotes:false,
				callDetailObject:{},
				isDropdown2Visible: false,
				dynamicTags: '',
				dynamicInsideTags: '',
				searchQuery: '',
				OnLoadMsgLimit : 100,
				ScrollCount : 1,
				temps: false,
				sched: false,
				sending: {},
				failed: {},
				emailData:{},
				priorityModalData:{},
				defaultProfileData:{},
				message: '',
				form: {
					name: '',
					body: '',
					date: '',
					time: ''
				},
				fileData: null,
				uplodedFilePath: '',
				uploadValue: 0,
				hideDiv:false,
				supportedType: ['audio/basic','audio/L24','audio/mp4','audio/mpeg','audio/ogg','audio/vorbis','audio/vnd.rn-realaudio',
					'audio/vnd.wave','audio/3gpp','audio/3gpp2','audio/ac3','audio/vnd.wave','audio/webm','audio/amr-nb','audio/amr',
					'video/mpeg','video/mp4','video/quicktime','video/webm','video/3gpp','video/3gpp2','video/3gpp-tt','video/H261',
					'video/H263','video/H263-1998','video/H263-2000','video/H264','image/jpeg','image/gif','image/png','image/bmp',
					'text/vcard','text/csv','text/rtf','text/richtext','text/calendar','text/directory','application/pdf'
					],
				imageFormatArray:['jpg','jpeg','png','gif','bmp'],
				audioFormatArray:['basic','L24','mpeg','ogg','vorbis','vnd.rn-realaudio','vnd.wave','3gpp','3gpp2','ac3','vnd.wave','amr-nb','amr'],
				videoFormatArray:['webm','mpeg','mp4','3gpp','quicktime','3gpp2','3gpp-tt','H261','H263','H263-1998','H263-2000','H264',],
				documentFormatArray:['pdf','vcard','csv','rtf','richtext','calendar','directory'],
				messageType:'',
				isSending:false,
				isScheduleTemplate:false,
				token:'',
				muted: false,
				onPhone: false,
				log: 'Connecting...',
				connection: null,
				callProspFullName:'',
				isShowTemplateList:true,
				templateForm:{
					Name:'',
					Body:'',
				},
				callForm:{
					title:'',
					notes:''
				},
				localConvo:null
			}
        },
		mounted() {
			this.$root.$on('bv::dropdown::show', bvEvent => {
				if(bvEvent.componentId === 'dropdown-m') {
					this.isDropdown2Visible = true;
				}
			})
			this.$root.$on('bv::dropdown::hide', bvEvent => {
				if(bvEvent.componentId === 'dropdown-m') {
					this.isDropdown2Visible = false;
				}
				if(this.isDropdown2Visible) {
					bvEvent.preventDefault()
				}
			})
		},
		updated() {
			//eslint-disable-next-line
			// console.log(this.convo);
			if (this.convo && this.convo.Unread) {
				// this.convo.Unread = 0;
				db.doc(`Conversations/${this.convo.id}`).update({Unread: 0});
				this.$store.commit('globals/SET', { var: 'unreadCountTotal', val: this.unreadCountTotal-1 });
				this.$store.dispatch('firebase/rebindConvosUnreadCount', {
					uid: this.user.Uid,
					id: this.user.id,
				})
			}
			if (this.convo && this.convo.hasOwnProperty('isMailExist') && this.convo.isMailExist) {
				this.convo.Unread = 0;
				db.doc(`Emails/${this.convo.emailConvoID}`).update({Unread: 0});
			}
		},
		created() {
			var self = this;

			// Fetch Twilio capability token from our Node.js server
			axios.get("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/token")
			.then(response => {
				this.token = response.data.token;
				Device.setup(this.token);
			}).catch(err => alert(`Could not fetch token: ${err}`));

			// Configure event handlers for Twilio Device
			Device.disconnect(function() {
				self.onPhone = false;
				self.connection = null;
				self.log = 'Call ended.';
			});

			Device.ready(function() {
				self.log = 'Connected';
			});
		}
    }
</script>

<style >
	#onlyDesktop{
		display: none !important;
	}
	#onlyDesktop1{
		display: none !important;
	}
	.my-modal .modal-dialog {
		max-width: 400px;
	}
	.emailndcallbtn:focus{
		box-shadow: none!important;
	}
	.input {
		resize: none;
	}

	.twemoji-textarea-outer > #twemoji-textarea {
		max-height: 100px;
	}
	/* .custom-dropdown button {
    border: 1px solid #dee2e6 im !important;
	} */
.custom-dropdown {
       border: 1px solid #dee2e6 !important;
    border-radius: 4px !important;
}
.custom-dropdown .dropdown-toggle{
	display: block !important;color: #042b79;padding: 5px 7px;    font-weight: bold;
}
.custom-dropdown .dropdown-toggle:after{
	display: none !important;
}
button#btn-emoji-default {
    margin-left: 0px ;
}
.show_star {
	background-color:  transparent;
}
.show_star:hover {
	background-color: transparent;fill: rgba(4,43,121,.3);
}
.red {
	background-color: transparent;
}
.before-icon .red {
	font-size: 18px;margin-right: 5px;
	color: red;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
}
.before-icon .yellow {
	font-size: 18px;
	color:#ffc107;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
}
.before-icon .gray  {
	font-size: 18px;
	color:gray;
	font-weight: 800;
	object-fit: contain;
	object-position: center;
}

.scedule-emoji button#btn-emoji-default {
    margin-left: 0px;margin-bottom: 50px;
    padding-left: 12px;
}




/* calling popup css */
.calling_icons button {
    border: none;padding:0px 15px;outline: none;
    background-color: transparent;
}

.calling_icons button i {
    font-size: 10px;
}
.calling_icons button:focus{
	outline: none;border: none;
}
button.mic_btn .fa-icon {
    font-size: 10px;
}

.calling-container {
    display: flex;
    align-items: center;
}

.calling_leftside > div {
    width: 70px;
    height: 70px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}





.calling_icons {
    background: rgb(200 213 236 / 11%);
    border-radius: 25px;
    padding: 7px 10px;
    display: flex;
    align-items: center;
}
.calling_icons button svg {
	fill: #fff !important;
	width: 15px !important;
	height: 20px !important;
}
button.reject_btn {
    background: red;
    padding: 0px;
    width: 30px;
    height: 30px;
    border-radius: 100%;
}
div#DailerModal___BV_modal_body_ {
    background: #02163d;padding:5px;
}
header#DailerModal___BV_modal_header_ {
    padding: 5px 20px;
}

#DailerModal .modal-dialog.modal-sm {
    max-width: 420px !important;
}
.calling-container span {
    font-size: 17px;
    color: #fff;
    font-weight: 700;
    /* margin: 0px 10px; */
    width: 100%;
}
.calling_icons button.reject_btn svg.text-blue.fa-icon {
    transform: rotate(
225deg
);
}
.calling_icons button:first-child{
	padding-right: 19px;
}



#DailerModal___BV_modal_content_ .modal-header .close {
	display: none !important;
}


h5#DailerModal___BV_modal_title_ {
    margin-bottom: 0;
    line-height: 1.5;
    font-size: 14px;
    color: #fff;
}
header#DailerModal___BV_modal_header_ {
    padding: 7px 20px;
    background: rgb(39 59 96);
    overflow: hidden;
}
.modal-content {
    border-radius: 12px;
    overflow: hidden;
}
div#DailerModal___BV_modal_body_ {
    background: #02163d;
    padding: 8px 8px;
}
/* .calling_leftside {
    width: 100px;
} */
.calling_leftside > div {
    width: 90px;
    border-radius: 8px;
    height: 90px;
    margin-top: -35px;
    background: #fff;
    display: flex;
    align-items: center;
}
.calling_rightside {
    width: 100%;
    margin-left: 10px;
    display: flex;
    align-items: center;
}
.calling-container span {
    font-size: 17px;
    color: #fff;
    font-weight: 700;
    /* margin: 0px 10px; */
    width: 100%;
}
button.mic_btn_mute {
    margin-right: 4px;
    padding-left: 11px !important;
    padding-right: 11px !important;
}
.calling_icons button:nth-child(2) svg {
    width: 17px !important;
}
.calling_icons button:nth-child(1) svg{
	width: 12px !important;
}
.calling_icons div button.mic_btn_mute svg {
    width: 20px !important;
}
.calling_icons button:nth-child(3) svg.text-blue.fa-icon {
    width: 17px !important;
}
.modal-content{
	border-radius: 8px !important;overflow: hidden;
}
.calling_icons button:nth-child(3){
    padding-left: 6px;
    padding-right: 20px;
 } 
 
 button.btn.border.schedule-upload.schedule-upload1.btn-outline {
    width: 37px;
    height: 37px;
    top: 140px;
    display: flex;
    align-items: center;
    padding: 0px !important;
}
.twemoji-textarea-outer > #twemoji-textarea {
    max-height: 126px;
    margin-left: 0;
}
.schedule-textbox .schedule-upload {
    /* bottom: 0 !important; */
    left: 10px !important;
    /* top: 50px !important; */
    position: absolute !important;
    z-index: 9;
    /* top: 0; */
    padding: 5px 7px !important;
    margin-bottom: 10px !important;
}
.schedule-textbox .schedule-textbox .twemoji-textarea-outer {
    max-height: 140px;
    min-height: 150px !important;
}
.schedule-textbox div#twemoji-textarea {
    min-height: 140px;
}

.testmove{
    display: block;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 6px;
    height: 80px;
    width: 340px;
    margin: 100px;
    background: rgb(10 35 85);
    color: white;
    z-index: 1111;
}
/* .modaltitle {
    background: rgb(39 59 96);
    display:block;
    width:100%;
    color: white;
  } */

.modaltitle{
	background: transparent;
    display: block;position: unset !important;
    width: 100%;
    color: white;
    font-weight: 600;
    letter-spacing: 0.5px;
}
.custom-btn:hover {
	color: #fff !important;
}
.custom-save-btn {
	margin-left: auto !important;
	margin-right: 0 !important;
}	
.custom-btn {
	background: #007bff !important;
	padding: 10px !important;
    color: #fff !important;
    font-size: 12px;
}
.custom-save-btn{
	display: flex !important;
	justify-content: center !important;
	width: 100%;
	max-width: 150px !important;
	text-align: center;
	margin-left: auto !important;
	margin-right: 0 !important;
}
.custom-border{
	border: 1px solid #ced4da;
	padding: 20px;
	border-radius: 4px;
}
#TemplateModal___BV_modal_content_ h5#TemplateModal___BV_modal_title_ {
	display: flex;
	width: 90%;
	justify-content: space-between;
}
button.reply-btn {
    position: absolute;
    right: 55px;
    /* top: 0; */
    /* bottom: 0; */
    /* display: flex; */
    align-items: center;
    height: auto;
    margin-top: -4px;
    background: #02163d;
    border: transparent;
}
button.reply-btn:focus{
	outline: none !important;border: none;box-shadow: none !important;
}
button.reply-btn:hover{
	background: #02163d;
}
header#EmailModal___BV_modal_header_ {
    position: relative;
}

.mobilemegoptn #dropdown-md__BV_toggle_{
	background: #fff;
    border: 1px solid #ddd;
    color: #042B79;
}
.mobilemegoptn ul{
	padding: 0px;
}
.mobilemegoptn ul.dropdown-menu{
	text-align: center;
	min-width: 3rem;
}
.mobilemegoptn ul.dropdown-menu li a.dropdown-item{
	padding: 0px 10px;
}
.btn-group.mobilemegoptn{
	display: none;
}
</style>

<style>
.manageConvoVarDiv ul{
	overflow-y: scroll;
    max-height: 350px;
}
.multi-range-slider .thumb::before{
	border: solid 4px #042b79;
}
.templatesearchbar{
	margin-bottom: 10px;
}
.form-group.dynamicformdiv{
	margin-bottom: 10px;
}
</style>